import React, { useEffect } from 'react';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import FooterTwo from '../../components/FooterTwo';
import ProcessingMessage from '../../components/processingMessage';
import LoggedNavbar from './components/LoggedNavbar';

function AdmProcess() {
   
    return (
        // <Styles>
        <>
            {/* Main Wrapper */}
            <LoggedNavbar/>
            <div className="main-wrapper contact-page">

                {/* Breadcroumb */}
                <BreadcrumbBox title="Admission" />
                <ProcessingMessage/>

                {/* <FooterTwo /> */}

            </div>
            </>
        // </Styles>
    )
}

export default AdmProcess;